export function checkId( id ) {
    let reg = /(\d{18})|(\d{17}x{1}$)/gi
    let isMatch = reg.test( id )
    return isMatch
}

export function checkPhone( phone ) {
    let reg = /^1[356789]\d{9}$/gi
    let isMatch = reg.test( phone )
    return isMatch
}